import { JToken } from 'generated-service-lib';
import { QueryPayload } from 'generated-service-lib/DocumentService';
import { DocumentResponse, DocumentsRequestBody } from 'services/types';
import { GeneratedDocumentService } from '../generatedServices';

export interface QueryPayloadOverride extends Omit<QueryPayload, 'document'> {
  document: {} & {
    [key: string]: Array<{
      operator: string;
      value: string; // this line
    }>;
  };
}

export interface QueryResponseMetadata {
  currentPage: number;
  hasNext: boolean;
  hasPrevious: boolean;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}
export class DocumentService {
  readonly unvalidatedClient: GeneratedDocumentService;
  constructor(domain?: string) {
    this.unvalidatedClient = new GeneratedDocumentService(domain);
  }

  //wrap methods here
  //untested
  getDocumentsByType = async (
    clientId: string,
    documentType: string,
    sortBy?: string | undefined,
    sortOrder?: string | undefined,
    pageSize?: number | undefined,
    page?: number | undefined
  ): Promise<any> => {
    return await this.unvalidatedClient
      .getDocsClientsByClientIdTypesByDocumentType({ clientId, documentType, sortBy, sortOrder, pageSize, page })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));
  };

  getDocument = async <T extends JToken | undefined>(
    clientId: string,
    documentType: string,
    id: string
  ): Promise<T & { id: string }> => {
    const result = await this.unvalidatedClient
      .getDocsClientsByClientIdTypesByDocumentTypeByDocumentId({ clientId, documentType, documentId: id })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));
    return result as T & { id: string };
  };
  saveDocument = async <T extends JToken | undefined>(
    clientId: string,
    documentType: string,
    body: T
  ): Promise<T & { id: string }> => {
    const result = await this.unvalidatedClient
      .postDocsClientsByClientIdTypesByDocumentType({ clientId, documentType, body })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));
    return result as T & { id: string };
  };

  getDocumentsByQuery = async (clientId: string, documentType: string, body: QueryPayloadOverride) => {
    const result = await this.unvalidatedClient
      .postDocsClientsByClientIdTypesByDocumentTypeQuery({
        clientId,
        documentType,
        body: (body as any) as QueryPayload,
      })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body));

    const data = result.data;
    const metadata = result.metadata as QueryResponseMetadata;
    return { data, metadata };
  };

  updateDocument = async (
    clientId: string,
    documentType: string,
    documentId: string,
    body?: {} & {
      [key: string]: JToken;
    }
  ) => {
    return await this.unvalidatedClient
      .putDocsClientsByClientIdTypesByDocumentTypeByDocumentId({ clientId, documentType, documentId, body })
      .then((res) => (typeof res.body === 'undefined' ? {} : res.body))
      .then((body) => (typeof body.data === 'undefined' ? {} : body.data));
  };
}
